module.exports = __webpack_public_path__ + "img/logoMarioViajes.60e10e60.png";